angular.module('dpw.components')
    .factory('collapse', [function () {
        var collapses = [];
        var active = -1;

        return {
            /**
             * Add a new collapse item into collapses array.
             *
             * @param item - Item to add.
             * @returns {number} The index of the item in the collapses.
             */
            add: function (item) {
                collapses.push(item);
                return collapses.length - 1;
            },

            active: function (index) {
                var item = collapses[index];

                if (active === index) {
                    item.source.removeClass('collapse-active');
                    active = -1;
                    deative([item]);
                    return;
                }
                active = index;
                item.source.addClass('collapse-active');
                showTarget(item.target);
                deative(collapses);
            }
        };

        function deative(elements) {
            angular.forEach(collapses, function (item, index) {
                if (index === active) {
                    return;
                }
                item.source.removeClass('collapse-active');
                hideTarget(item.target);
            });
        }

        function hideTarget(target) {
            angular.element(target).addClass('ng-hide');
        }

        function showTarget(target) {
            angular.element(target).removeClass('ng-hide');
        }
    }])
    .directive('dpwCollapse', ['collapse', function (collapse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var target = attrs['target'];
                if (!angular.isDefined(target) || !angular.element(target)) {
                    return;
                }
                var id = collapse.add({
                    source: element,
                    target: target
                });

                element.on('click', function (event) {
                    event.preventDefault();
                    scope.$apply(function () {
                        collapse.active(id);
                    });
                });
            }
        };
    }]);